import type { StorePlatform } from '@cartly/shared';

export const PLATFORM_LABELS: Record<StorePlatform, string> = {
  shopify: 'Shopify',
  woocommerce: 'WooCommerce',
  custom_php: 'Custom PHP',
  laravel: 'Laravel',
  django: 'Django',
  flask: 'Flask',
  fastapi: 'FastAPI',
  node: 'Node.js',
  other: 'Other / REST API',
};

/** Shopify connects through the Shopify app (Phase 3), not this form. */
export const CONNECTABLE_PLATFORMS = (Object.keys(PLATFORM_LABELS) as StorePlatform[]).filter(
  (p) => p !== 'shopify',
);

export type SdkLanguage = 'php' | 'python' | 'node' | 'curl';

export function sdkFor(platform: StorePlatform): SdkLanguage {
  if (platform === 'custom_php' || platform === 'laravel') return 'php';
  if (platform === 'django' || platform === 'flask' || platform === 'fastapi') return 'python';
  if (platform === 'node') return 'node';
  return 'curl';
}
